<template>
  <div class="Div">
    <div class="backimg">

      <img
        class="img"
        :src="details.background_img"
        alt=""
      >
    </div>
    <p class="Title">
     {{details.welcome_name_cn}}
    </p>
    <section class="sectionContent" v-html="details.welcome_content_cn">
    
    </section>
  </div>
</template>
<script>
import { welcome } from "@/api/Overview";
export default {
  name: "Welcome",
  data(){
    return {
      details:{}
    }
  },
  created(){
    var sid=this.$route.query.sid
    welcome({
      park:sid
    }).then(res=>{
      this.details=res.data.info
      // console.log(res.data)
    })
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.Div {
  position: relative;
  width: 100%;
  //   min-height: 100%;
  padding: 0.1px 0;
  background: #f5f5f5;
  .backimg {
    position: absolute;
    width: 100%;
    height: px2Rem(540px);
    &::after {
      display: block;
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.4);
      //   z-index: 1;
    }
    .img {
      //   position: absolute;
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
.Title {
  position: relative;
  margin-top: px2Rem(183px);
  font-size: px2Rem(80px);
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
}
.sectionContent {
  position: relative;
  width: px2Rem(1300px);
  padding: px2Rem(50px) px2Rem(30px);
  margin: px2Rem(180px) auto;
  background: rgba(255, 255, 255, 1);
  font-size: px2Rem(30px);
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height:px2Rem(40px);
  .name{
      padding-top: px2Rem(20px);
      text-align: right;

  }
}
</style>


// WEBPACK FOOTER //
// src/views/OverviewAndWelcome/WelcomeDetail.vue